import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { isAuthenticated, setSessionExpiredCallback } from './utils/auth';
import Login from './components/Login';
import Home from './components/Home';
import Register from './components/Register';
import Logout from './components/Logout';
import './index.css';

function ProtectedRoute({ children }) {
  const [authStatus, setAuthStatus] = useState(null);
  
  useEffect(() => {
    isAuthenticated().then(status => {
      // console.log("ProtectedRoute: isAuthenticated() = " + status);
      setAuthStatus(status);
    });
  }, []);
  
  if (authStatus === null) return <div>Loading...</div>;
  return authStatus ? children : <Navigate to="/login" />;
}

function NotLoggedIn({ children }) {
  const [authStatus, setAuthStatus] = useState(null);
  
  useEffect(() => {
    isAuthenticated().then(status => {
      // console.log("NotLoggedIn: isAuthenticated() = " + status);
      setAuthStatus(status);
    });
  }, []);
  
  if (authStatus === null) return <div>Loading...</div>;
  return authStatus ? <Navigate to="/" /> : children;
}

function App() {
  const [sessionExpired, setSessionExpired] = useState(null);

  useEffect(() => {
    setSessionExpiredCallback((data) => {
      setSessionExpired(data);
    });
  }, []);

  return (
    <Router>
      {sessionExpired && (
        <div className="modal-overlay">
          <div className="modal-content modal-content-compact">
            <h3>Session Expired</h3>
            <p>
              {sessionExpired.firstName} {sessionExpired.lastName} ({sessionExpired.userId})
            </p>
            <p>Your session to Applucent has expired. Login to start a new session.</p>
            <p><strong>{sessionExpired.message}</strong></p>
            <button 
              className="btn-save" 
              onClick={() => window.location.href = '/login'}
            >
              Login
            </button>
          </div>
        </div>
      )}
      <Routes>
        <Route path="/login" element={
          <NotLoggedIn>
            <Login />
          </NotLoggedIn>
        } />
        <Route path="/register" element={<Register />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/" element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;